<template>
  <div>
    <div>
      <div>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg12 xl12 >
            <v-toolbar color="primary" dark >
              <v-toolbar-title>Báo cáo trường</v-toolbar-title>
              <v-spacer/>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-layout>
          <v-flex xs12 sm12 md12 lg12 xl12 >
            <v-layout>
              <v-flex xs4 style="padding-left: 50px;">
                <i-datepicker :label="$t('lang.common.fromDate')"
                              v-validate="'date_before_now'"
                              :data-vv-as="$t('lang.common.fromDate')"
                              name="fromDate"
                              @clearText=""
                              v-model="search.fromDate"
                              @change="changeDay"
                              value=""
                              clearable
                              :minDate="minDay()"
                              :maxDate="maxDay()"
                              :error-messages="errors.first('fromDate')"
                />
              </v-flex>
              <v-flex xs4 style="padding-left: 50px; padding-right: 50px">
                <i-datepicker
                    :label="$t('lang.common.toDate')"
                    v-validate="'date_before_now'"
                    :data-vv-as="$t('lang.common.toDate')"
                    name="toDate"
                    v-model="search.toDate"
                    @clearText=""
                    clearable
                    @change="changeDay"
                    value=""
                    :maxDate="maxDay()"
                    :error-messages="errors.first('toDate')"
                />
              </v-flex>
              <v-flex xs1  style="justify-content: center; align-content: center">
                <div class="text-title" >
                  <v-btn color="primary" @click="onView">
                    Xem báo cáo
                  </v-btn>
                </div>
              </v-flex>
              <v-flex xs1 style="justify-content: center; align-content: center">
                <div class="text-title">
                  <v-btn color="primary" @click="onPrint">
                    Xuất báo cáo
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
      </div>
      <div id="content-to-pdf" style="visibility: hidden">
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg12 xl12 >
            <v-layout wrap>
              <v-flex xs11 sm11 md11 lg11 xl11 style="margin-left: 40px; margin-right: 40px; background: #00105A;  opacity: 80%; border-top-left-radius: 30px;
              border-top-right-radius: 30px; padding-bottom: 10px">
                <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding: 20px; color: white">
                  <div style="width: 45%; margin-left: 70px">
                    <div style="font-size: 25px; font-weight: bold">THÔNG TIN BÁO CÁO</div>
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;padding-left: 20px; color: white">
                  <div style="width: 45%; margin-left: 50px; font-size: 20px">
                    <ul>
                      <li>
                        Tên : Báo cáo trường theo giai đoạn
                      </li>
                      <li>
                        Trường : {{schoolName}}
                      </li>
                      <li>
                        Tạo bởi : {{username}}
                      </li>
                    </ul>
                  </div>
                  <div style="width: 45%; font-size: 20px">
                    <ul>
                      <li>
                        Ngày tạo : {{formattedCreateDate}}
                      </li>
                      <li>
                        Ngày bắt đầu : {{formattedFromDate}}
                      </li>
                      <li>
                        Ngày kết thúc : {{formattedToDate}}
                      </li>
                    </ul>
                  </div>
                </div>
              </v-flex>
              <v-flex xs11 sm11 md11 lg11 xl11 style="margin-left: 40px; margin-right: 40px; background: #ece8e7;  opacity: 80%">
                <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding: 20px;">
                  <div style="width: 45%">
                    <div class="chart-container">
                      <gru-chart id="summary_week"
                                 type="pie"
                                 label=""
                                 query="getSoluongTrangthaiPeriod"
                                 :search="search"
                                 :label="label1"
                                 label-field="Trạng thái"
                                 index-field="Số lượng"

                      />
                    </div>
                  </div>
                  <div style="width: 45%">
                    <div class="chart-container">
                      <school-chart id="tongquan"
                                    type="bar"
                                    label=""
                                    query="getDulieuTongquanPeriod"
                                    :search="search"
                                    :label="label1"
                                    label-field="Trạng thái"
                                    index-field="Số lượng"

                      />
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex xs11 sm11 md11 lg11 xl11 style="margin-left: 40px; margin-right: 40px ;margin-top: 20px; border-radius: 30px;  background: #ece8e7; opacity: 80%">
            <v-layout wrap>
<!--              <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 5px">-->
<!--                <div class="text-title" align="left" style="font-size: 24px; font-weight: bold; padding-top: 30px; color: black; opacity: 100%">Dữ liệu học chi tiết</div>-->
<!--              </v-flex>-->
              <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding: 20px; color: white">
                <div style="width: 45%; margin-left: 70px; font-size: 24px; font-weight: bold">
                  <div style="font-size: 22px; color: black">Dữ liệu học chi tiết</div>
                </div>
              </div>
              <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px; display: flex; align-items: flex-end; justify-content: flex-end;">
                <div class="row111">
                  <div class="circle111"></div>
                  <span style="color: #747271">Lớp 3-4t: {{count34}}</span>
                </div>
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px; display: flex; align-items: center; justify-content: center;">
                <div class="row111">
                  <div class="circle112"></div>
                  <span style="color: #747271">Lớp 4-5t: {{count45}}</span>
                </div>
              </v-flex>
              <v-flex xs4 sm4 md4 lg4 xl4 style="padding: 5px; display: flex; align-items: flex-start; justify-content: flex-start;">
                <div class="row111">
                  <div class="circle113"></div>
                  <span style="color: #747271">Lớp 5-6t: {{count56}}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 5px">
                <v-layout wrap>
                  <v-flex xs6 sm6 md6 lg6 xl6 style="padding-left: 50px; display: flex; align-items: center; justify-content: left;">
                    <v-layout wrap>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            Từ vựng
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                      </v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            <div class="circle">{{countSoluongTuvung}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                        <school-chart-detail id="tuvung"
                                             type="bar"
                                             label=""
                                             query="getSoluongTuvung"
                                             :search="search"
                                             :label="label1"
                                             label-field="Trạng thái"
                                             index-field="Số lượng"

                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 xl6 style="padding-left: 50px; display: flex; align-items: center; justify-content: left;">
                    <v-layout wrap>
                      <v-flex xs4 sm4 md4 lg4 xl4 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            Thời lượng xem video
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 sm6 md6 lg6 xl6 style="display: flex; align-items: center; justify-content: left;">
                      </v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            <div class="circle">{{countThoiluongVideo}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                        <school-chart-detail id="thoiluong"
                                             type="bar"
                                             label=""
                                             query="getThoiluongxemvideo"
                                             :search="search"
                                             :label="label1"
                                             label-field="Trạng thái"
                                             index-field="Số lượng"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 xl6 style="padding-left: 50px; display: flex; align-items: center; justify-content: left;">
                    <v-layout wrap>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            Mẫu câu
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                      </v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            <div class="circle">{{countSoluongMaucau}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                        <school-chart-detail id="maucau"
                                             type="bar"
                                             label=""
                                             query="getMaucau"
                                             :search="search"
                                             :label="label1"
                                             label-field="Trạng thái"
                                             index-field="Số lượng"

                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 xl6 style="padding-left: 50px; display: flex; align-items: center; justify-content: left;">
                    <v-layout wrap>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            Trò chơi
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                      </v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            <div class="circle">{{countSoluongTrochoi}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                        <school-chart-detail id="trochoi"
                                             type="bar"
                                             label=""
                                             query="getTrochoi"
                                             :search="search"
                                             :label="label1"
                                             label-field="Trạng thái"
                                             index-field="Số lượng"

                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 sm6 md6 lg6 xl6 style="padding-left: 50px; display: flex; align-items: center; justify-content: left;">
                    <v-layout wrap>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            Video
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                      </v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="display: flex; align-items: center; justify-content: left;">
                        <v-layout>
                          <v-flex xs12 sm12 md12 lg12 xl12 class="wrap1">
                            <div class="circle">{{countSoluongvideo}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 xl8 style="display: flex; align-items: center; justify-content: left;">
                        <school-chart-detail id="video"
                                             type="bar"
                                             label=""
                                             query="getVideo"
                                             :search="search"
                                             :label="label1"
                                             label-field="Trạng thái"
                                             index-field="Số lượng"

                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs11 sm11 md11 lg11 xl11 style="margin-left: 40px; margin-right: 40px; margin-top: 20px; background: #ece8e7;  border-radius: 30px;
           opacity: 80%; padding-bottom: 10px">
            <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding: 20px; color: white">
              <div style="width: 45%; margin-left: 70px; font-size: 24px; font-weight: bold">
                <div style="font-size: 22px; color: black">Tổng kết </div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;padding-left: 20px; color: black; font-size: 20px">
              <div style="width: 95%; margin-left: 50px">
                <div>🔹 {{schoolName}} triển khai được {{totalClass}} lớp học tiếng Anh.</div>
                <div>🔹 Nhận xét chung</div>
                <div>Nhóm lớp 3-4 tuổi chiếm {{percent34}}%</div>
                <div>Nhóm lớp 4-5 tuổi chiếm {{percent45}}%</div>
                <div>Nhóm lớp 5-6 tuổi, chiếm {{percent56}}%</div>
                <div>🔹 Nhận xét chi tiết </div>
                <div>Nhóm lớp 3-4 tuổi đã hoàn thành {{class34Info[0]}} chương. Trong đó có {{class34Info[1]}} từ vựng, {{class34Info[2]}} mẫu câu, {{class34Info[3]}} video, {{class34Info[4]}} trò chơi, thời lượng xem video là {{class34Info[5]}}</div>
                <div>Nhóm lớp 4-5 tuổi đã hoàn thành {{class45Info[0]}} chương. Trong đó có {{class45Info[1]}} từ vựng, {{class45Info[2]}} mẫu câu, {{class45Info[3]}} video, {{class45Info[4]}} trò chơi, thời lượng xem video là {{class45Info[5]}}</div>
                <div>Nhóm lớp 5-6 tuổi đã hoàn thành {{class56Info[0]}} chương. Trong đó có {{class56Info[1]}} từ vựng, {{class56Info[2]}} mẫu câu, {{class56Info[3]}} video, {{class56Info[4]}} trò chơi, thời lượng xem video là {{class56Info[5]}}</div>
              </div>

            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>


  </div>

</template>
<script>
  import GruChart from "@/components/form/GruChart";
  import jsPDF from "jspdf";
  import html2canvas from "html2canvas";
  import moment from "moment";
  import {Validator} from "vee-validate";
  import SchoolChart from "@/components/form/SchoolChart";
  import SchoolChartDetail from "@/components/form/SchoolChartDetail";
  import axios from "axios";
  export default {
    components: {SchoolChartDetail, SchoolChart, GruChart},
    data() {
      return {
        label1: [
          {label: "thứ 2", color: "#808AC3"},
          {label: "thứ 3", color: "#4958A9"},
          {label: "thứ 4", color: "#162778"},
          {label: "thứ 5", color: "green"},
          {label: "thứ 6", color: "violet"},
          {label: "thứ 7", color: "gray"},
          {label: "chủ nhật", color: "purple"},
          {label: "nghỉ", color: "brown"},
        ],
        countSoluongTuvung: 0,
        countSoluongMaucau: 0,
        countSoluongTrochoi:0,
        countSoluongvideo:0,
        countThoiluongVideo:0,
        count34: 0,
        count45: 0,
        count56: 0,
        title: "Tổng số lớp học tiếng anh: 381",
        schoolName: "",
        username: "",
        totalClass: "",
        percent34: "",
        percent45: "",
        percent56 :"",
        class34Info: [20,30,40],
        class45Info: [20,30,40],
        class56Info: [20,30,40],
        dateCreate : new Date(),
        formattedFromDate: new Date((new Date()).setDate(new Date().getDate() - 7)).toLocaleDateString("vi-VN"),
        formattedToDate: new Date().toLocaleDateString("vi-VN"),
        search: {
          fromDate: (new Date()).setDate(new Date().getDate() - 7),
          toDate: new Date(),
        },
      }
    },
    created() {
      this.title = "Tổng số lớp học tiếng anh: 382"

    },
    mounted(){
      Validator.extend("endDateAfterStart", {
        validate: (value, {otherValue}) => {
          let mm = moment(value).hour(23).minute(59).second(59);
          let valid = mm.isSameOrAfter(this.search.fromDate); // false
          return {
            valid: valid,
            data: {
              message: "Đến ngày phải sau Từ ngày"
            }
          };
          ;
        },
        getMessage: (field, params, data) => {
          return "Đến ngày phải sau Từ ngày";
        }
      });
      this.getData();
    },
    methods: {
      changeDay(){
        document.getElementById("content-to-pdf").style.visibility = "hidden";
        this.formattedFromDate = new Date(this.search.fromDate).toLocaleDateString("vi-VN");
        this.formattedToDate = new Date(this.search.toDate).toLocaleDateString("vi-VN");
        this.getData();
      },
      getData(){
        axios.post(
            process.env.VUE_APP_API_URL + "/chart/getGeneralInfo/", this.search
        )
            .then(
                (data) => {
                  this.countSoluongTuvung = data.countSoluongTuvung;
                  this.countSoluongMaucau = data.countSoluongMaucau;
                  this.countSoluongTrochoi = data.countSoluongTrochoi;
                  this.countSoluongvideo = data.countSoluongvideo;
                  this.countThoiluongVideo = data.countThoiluongVideo;
                  this.count34 = data.count34;
                  this.count45 = data.count45;
                  this.count56 = data.count56;
                  this.schoolName = data.schoolName;
                  this.username = data.username;
                  this.totalClass = this.count34 + this.count45 + this.count56;
                  let sum = 1;
                  if(this.totalClass > 0){
                    sum = this.totalClass;
                  }
                  this.percent34 = ((this.count34 * 100) / sum).toFixed(1);
                  this.percent45 = ((this.count45 * 100) / sum).toFixed(1);
                  this.percent56 = ((this.count56 * 100) / sum).toFixed(1);
                  this.class34Info = data.class34Info;
                  this.class45Info = data.class45Info;
                  this.class56Info = data.class56Info;
                }
            );
      },
      onView(){
        document.getElementById("content-to-pdf").style.visibility = "visible";
      },
      onPrint(){
       document.getElementById("content-to-pdf").style.visibility = "visible";
        this.downloadPDF();
       //document.getElementById("content-to-pdf").style.visibility = "hidden";
      },
      maxDay(){
        let day = moment().format("YYYY-MM-DD");
        console.log(day);
        return day;
      },
      minDay(){
        let currentYear = moment().year();
        let currentMonth = moment().month() + 1; // Lưu ý: month() trong Moment.js tính từ 0 (0 = Tháng 1)

        let targetYear = currentMonth >= 8 ? currentYear : currentYear - 1;
        let minDate = moment(`${targetYear}-08-01`).format("YYYY-MM-DD");

        console.log(minDate);
        return minDate;
      },
      async downloadPDF() {
        // const element = document.getElementById("content-to-pdf");
        // const canvas = await html2canvas(element);
        // const imgData = canvas.toDataURL("image/png");
        //
        // // const pdf = new jsPDF("p", "mm", "a4");
        // // pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
        // // pdf.save("download.pdf");
        //
        // // Create a PDF in Landscape mode
        // const pdf = new jsPDF("landscape", "mm", "a4"); // 'landscape' mode
        // const pageWidth = 297; // A4 landscape width
        // const pageHeight = 210; // A4 landscape height
        // const imgWidth = pageWidth - 20; // Adjust width for margin
        // const imgHeight = (canvas.height * imgWidth) / canvas.width;
        //
        // let yPos = 0;
        // let pageCount = 0;
        //
        // while (yPos < canvas.height) {
        //   pdf.addImage(
        //       imgData,
        //       "PNG",
        //       10,
        //       10 - yPos,
        //       imgWidth,
        //       imgHeight
        //   );
        //
        //   yPos += pageHeight * (canvas.width / imgWidth);
        //
        //   if (yPos < canvas.height) {
        //     pdf.addPage();
        //   }
        //   pageCount++;
        // }


        const element = document.getElementById("content-to-pdf");
        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
        pdf.save("baocao.pdf")
      }
    },
    computed: {
      formattedCreateDate() {
        return this.dateCreate.toLocaleDateString('vi-VN'); // Formats as dd/MM/yyyy
      },
       },

  }

</script>

<style scoped>
.circle {
  width: 80px;
  height: 80px;
  color: #00105A; /* Màu chữ */
  background-color: #BAC3FF; /* Màu nền */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  /*position: relative; !* Để thêm viền trong *!*/
  /*box-shadow: 0 0 0 5px #1e2669; !* ✅ Viền trong *!*/
}
.circle2 {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  text-align: center;

}
.wrap1 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
}
.wrap2 {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
}
.report {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: xxx-large;
}
.detail {
  padding-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  font-weight: bold;
}
.chart-container {
  padding-top: 30px;
  padding-bottom: 30px;
  //background: #d5d5d5;
}
.circle111 {
  width: 15px; /* Độ rộng */
  height: 15px; /* Chiều cao */
  background-color: #808AC3; /* Màu đỏ */
  border-radius: 50%; /* Làm tròn */
}
.circle112 {
  width: 15px; /* Độ rộng */
  height: 15px; /* Chiều cao */
  background-color: #4958A9; /* Màu đỏ */
  border-radius: 50%; /* Làm tròn */
}
.circle113 {
  width: 15px; /* Độ rộng */
  height: 15px; /* Chiều cao */
  background-color: #162778; /* Màu đỏ */
  border-radius: 50%; /* Làm tròn */
}
.row111 {
  display: flex; /* ✅ Hiển thị trên cùng một hàng */
  align-items: center; /* ✅ Căn giữa theo chiều dọc */
  gap: 8px; /* ✅ Khoảng cách giữa hình tròn và văn bản */
}
</style>
